export const PURCHASE_ORDER_FILE_ENTITY_TYPE = 'PurchaseOrder';
export const PURCHASE_ORDER_FILE_SOURCE_COLLECTION = 'purchase_order';
export const PURCHASE_ORDER_FILE_MAX_BYTES = 10 * 1024 * 1024;
export const PURCHASE_ORDER_FILE_MAX_COUNT = 20;
export const PURCHASE_ORDER_FILE_ALLOWED_MIME_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/webp',
];
//# sourceMappingURL=file-constants.js.map